import React from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';
import { getQueryParamsByName } from './lib/utils/browser';
import {
    GENERIC_LOGO,
    MUSIC_PREMIUM_LOGO,
    MUSIC_PREMIUM_QUERY_STRING_VALUE,
    STANDARD_LOGO,
    YOUTUBE_GENERIC_QUERY_STRING_VALUE,
} from './constants';

const App = () => {
    const premiumQueryStringValue = getQueryParamsByName('ytpid') || '';
    let logoUrl;
    switch (premiumQueryStringValue) {
        case MUSIC_PREMIUM_QUERY_STRING_VALUE:
            logoUrl = MUSIC_PREMIUM_LOGO;
            break;
        case YOUTUBE_GENERIC_QUERY_STRING_VALUE:
            logoUrl = GENERIC_LOGO;
            break;
        default:
            logoUrl = STANDARD_LOGO;
            break;
    }
    const isMusicPremium = premiumQueryStringValue === MUSIC_PREMIUM_QUERY_STRING_VALUE;

    return (
        <div className="sid-verification-form">
            <div className={`sid-headband ${isMusicPremium ? 'sid-headband--musicpremium' : ''}`}>
                <img className="sid-youtube-logo" alt="YouTube logo" src={logoUrl} />
            </div>
            <VerificationForm programId={programId} />
        </div>
    );
};

export default App;
